import { useMemo } from 'react'

import { useIsAuthed } from 'components/AuthShield'
import { FEATURE_NAMES } from 'components/ConfiguredDynamicFeatureProvider/features'
import { useIsDynamicFeatureEnabled } from 'components/DynamicFeatureProvider/use-is-dynamic-feature-enabled'

import Recent from './Recent'
import StartYourSearch from './StartYourSearch'
import YouMayAlsoLike from './YouMayAlsoLike'

export const useFocusDropdownSections = () => {
  const isAuthed = useIsAuthed()
  const showRecent = useIsDynamicFeatureEnabled(FEATURE_NAMES.CollegeSearch)
  const showYouMayAlsoLike = useIsDynamicFeatureEnabled(FEATURE_NAMES.PreferencesSearch)

  const sections = useMemo(() => {
    const output: any[] = [StartYourSearch]
    if (!isAuthed) {
      return output
    }
    if (showRecent) {
      output.push(Recent)
    }
    if (showYouMayAlsoLike) {
      output.push(YouMayAlsoLike)
    }
    return output
  }, [isAuthed, showRecent, showYouMayAlsoLike])

  return sections
}
